import type { FeatureCollection } from 'geojson';

import { formatAirValveDate, readHighRiskAirValveProperties } from '@/components/map/utils/airValveFeatureProperties';
import { exportRowsToFile, type ExportFormat } from './exportWorkbook';
import { toLngLatTuple } from './mapUtils';

export function buildHighRiskAirValveHeaders(): string[] {
    return ['Asset Number', 'Client', 'DMA', 'Date Identified', 'Reason', 'W3W', 'Longitude', 'Latitude'];
}

/**
 * Generates and triggers a download for the given high-risk air valves (the GeoJSON
 * FeatureCollection returned by GET /airvalves/hr) in the requested format (Excel .xlsx or .csv).
 *
 * Returns false without calling saveAs when the collection is empty, letting the caller
 * surface a "no data" message; returns true when a file was downloaded.
 */
export async function exportHighRiskAirValves(
    data: FeatureCollection,
    fileName: string,
    format: ExportFormat,
): Promise<boolean> {
    const rows = data.features.map((feature) => {
        const props = readHighRiskAirValveProperties(feature.properties);
        const coords = feature.geometry.type === 'Point' ? toLngLatTuple(feature.geometry.coordinates) : undefined;
        return [
            props.name,
            props.sc ?? '',
            props.dma,
            formatAirValveDate(props.identified) ?? '',
            props.reasons ?? '',
            props.w3w ?? '',
            coords?.[0] ?? '',
            coords?.[1] ?? '',
        ];
    });

    return exportRowsToFile({
        sheetName: 'High Risk Air Valves',
        headers: buildHighRiskAirValveHeaders(),
        rows,
        fileName,
        format,
    });
}
